export const DOE = {
    SET_IS_LOADING: 'SET_IS_LOADING',
    SET_PDF_IS_LOADING: 'SET_PDF_IS_LOADING',
    SET_ITEM: 'SET_ITEM',
    SET_NB_ITEMS: 'SET_NB_ITEMS',
    RESET_ITEMS: 'RESET_ITEMS',
    SET_FILTER_PROJET: 'SET_FILTER_PROJET',
    SET_FILTER_LIBELLE: 'SET_FILTER_LIBELLE',
    SET_PAGE: 'SET_PAGE',
    SET_NB_OF_PAGES: 'SET_NB_OF_PAGES',
    SET_SCROLL: 'SET_SCROLL',
    ADD_ITEMS: 'ADD_ITEMS',
    SET_SORT: 'SET_SORT',
};
